





























import { Vue, Component } from "vue-property-decorator";

// Enums/Data
import { DataModules } from "@/store/modules/data";

@Component({
  components: {
    "support-departments-listing": () =>
      import(
        "@/components/app/admin/settings/supportDepartments/supportDepartmentsListing.vue"
      )
  }
})
export default class TicketDepartmentsView extends Vue {
  // Methods

  public createDepartment() {
    if (!this.canCreate) return;

    this.$store.dispatch(
      `data/${DataModules.SUPPORT_DEPARTMENTS}/openManageSupportDepartmentModal`,
      {
        events: {
          success: () => {
            this.$bus.$emit("RefreshSupportDepartments");
          }
        }
      }
    );
  }

  // Computed

  public get canCreate() {
    return this.$userCan("create_tickets_departments");
  }

  public get cta() {
    if (!this.canCreate) return "";

    return this.$t("_action.create_department");
  }
}
